/** Console / docs links for SMS setup guide (Step 3). */
export function getSmsProviderConsoleLink(providerType?: string | null): {
  href: string;
  labelKey: 'TWILIO_CONSOLE' | 'PLIVO_CONSOLE';
} | null {
  if (providerType === 'twilio') {
    return { href: 'https://console.twilio.com/', labelKey: 'TWILIO_CONSOLE' };
  }
  if (providerType === 'plivo') {
    return { href: 'https://console.plivo.com/', labelKey: 'PLIVO_CONSOLE' };
  }
  return null;
}

export function getSmsAccountHelpUrl(providerType?: string | null): string | undefined {
  if (providerType === 'twilio') {
    return 'https://help.twilio.com/articles/14726256820123-What-is-a-Twilio-Account-SID-and-where-can-I-find-it';
  }
  if (providerType === 'plivo') {
    return 'https://www.plivo.com/docs/sms/';
  }
  return undefined;
}
